// extracted by mini-css-extract-plugin
export default {"root":"booking_note_edit-module___root___f5c2eecf"};